// 特定の要素の閲覧ログをサーバに送信する
// 使い方: data-view-logを計測したい要素に追加する。data-view-log内に下記を指定する。
//   tag: 要素を識別するためのタグ。一意。
//   action: 任意。ログ送信のHTTPメソッド。'get' or 'post'。デフォルトは'post'。
//   path: ログ送信先のパス。
//   request_id: 任意。PVのリクエストID。どのPVに紐づくものか判別できるようにするためのもの。
//   margin: 任意。IntersectionObserverに設定するrootMargin。デフォルトは0px。
//   count_only_once: 任意。trueにすると、要素が画面内に入った最初の1回だけログを送信する。デフォルトはfalse。
// ※ 閲覧時間のログを送るjsは app/assets/javascripts/themes/send_view_time_log.es6
jQuery(function ($) {
  // data-view-logをパース
  const parseViewLogData = (element) => {
    try {
      const dataAttr = element.getAttribute('data-view-log')
      return dataAttr ? JSON.parse(dataAttr) : null
    } catch (error) {
      console.error('Invalid data-view-log format:', error)
      return null
    }
  }

  // ログを送る
  class Logger {
    constructor(action, logPath, requestId) {
      this.action = action || 'post'
      this.logPath = logPath
      this.requestId = requestId || ''
      this.initialize()
    }

    initialize() {
      this.sendLog()
    }

    sendLog() {
      const params = {}

      if (this.requestId) {
        params.request_id = this.requestId
      }

      if (this.action === 'get') {
        $.get(this.logPath, params)
      } else {
        $.post(this.logPath, params)
      }
    }
  }

  // IntersectionObserverを設定する
  class ViewLogIntersectionObserver {
    constructor(element) {
      this.defaultRootMargin = '0px'
      this.element = element
      this.intersectionObserver = null
      this.initialize()
    }

    initialize() {
      this.newIntersectionObserver()
    }

    // NOTE: 要素毎にrootMarginを設定できるようにするため、要素毎にIntersectionObserverを作成している
    newIntersectionObserver() {
      const viewLogData = parseViewLogData(this.element)
      if (!viewLogData) return

      const rootMargin = viewLogData.margin || this.defaultRootMargin

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // 要素が画面内に入ったらログを送る
          if (entry.isIntersecting) {
            const currentViewLogData = parseViewLogData(this.element)
            if (!currentViewLogData) return

            const countOnlyOnce = currentViewLogData.count_only_once
            const alreadySent = this.element.getAttribute('data-sent-log') === 'true'

            // count_only_once: true かつ既にログを送信済みの場合は何もしない
            if (countOnlyOnce === true && alreadySent) {
              return
            }

            new Logger(currentViewLogData.action, currentViewLogData.path, currentViewLogData.request_id)

            // count_only_once: true の場合、ログ送信後にdata-sent-log: trueを付与
            if (countOnlyOnce === true) {
              this.element.setAttribute('data-sent-log', 'true')
            }
          }
        })
      }, {
        rootMargin
      })

      intersectionObserver.observe(this.element)

      this.intersectionObserver = intersectionObserver
    }

    deleteIntersectionObserver() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect()
        this.intersectionObserver = null
      }
    }
  }

  // 要素毎にviewLogIntersectionObserverを設定する
  class SettingByElements {
    constructor() {
      this.settingByTags = [] // 例: [{ tag: 'hoge', viewLogIntersectionObserver: ViewLogIntersectionObserver }]
    }

    updateSettings() {
      const alreadySetTags = new Set(this.settingByTags.map(tk => tk.tag))
      const currentTargetElements = Array.from(document.querySelectorAll('[data-view-log]'))
      const processedData = this.processElements(currentTargetElements, alreadySetTags)

      // 新しい設定を追加
      processedData.elementsToAdd.forEach(({ element, viewLogData }) => {
        this.newSetting(element, viewLogData)
      })

      // 不要な設定を削除
      processedData.tagsToRemove.forEach(tag => this.deleteSetting(tag))
    }

    processElements(elements, alreadySetTags) {
      const currentTags = new Set()
      const elementsToAdd = []
      const tagsToStopMonitoring = []

      elements.forEach(element => {
        const viewLogData = parseViewLogData(element)
        if (!viewLogData?.tag) return

        const tag = viewLogData.tag
        const alreadySent = element.getAttribute('data-sent-log') === 'true'
        const isAlreadySet = alreadySetTags.has(tag)
        const shouldStopMonitoring = viewLogData.count_only_once === true && alreadySent

        currentTags.add(tag)

        // 設定を追加する要素を抽出
        if (!isAlreadySet && !shouldStopMonitoring) {
          elementsToAdd.push({ element, viewLogData })
        }

        // 監視を停止する要素を抽出
        if (isAlreadySet && shouldStopMonitoring) {
          tagsToStopMonitoring.push(tag)
        }
      })

      // DOMから削除された要素を抽出
      const tagsToDeleteFromDOM = Array.from(alreadySetTags).filter(tag => !currentTags.has(tag))

      // 削除対象のタグをマージ
      const tagsToRemove = [...new Set([...tagsToStopMonitoring, ...tagsToDeleteFromDOM])]

      return {
        elementsToAdd,
        tagsToRemove
      }
    }

    newSetting(element, cachedViewLogData = null) {
      const viewLogData = cachedViewLogData || parseViewLogData(element)
      if (!viewLogData?.tag) return

      const viewLogIntersectionObserver = new ViewLogIntersectionObserver(element)
      this.settingByTags.push({
        tag: viewLogData.tag,
        viewLogIntersectionObserver
      })
    }

    deleteSetting(deleteTargetTag) {
      const deleteTargetSetting = this.settingByTags.find((tk) => tk.tag === deleteTargetTag)
      if (!deleteTargetSetting) return

      deleteTargetSetting.viewLogIntersectionObserver.deleteIntersectionObserver()
      this.settingByTags = this.settingByTags.filter((tk) => tk.tag !== deleteTargetTag)
    }
  }

  // MutationObserverを設定する
  class ViewLogMutationObserver {
    constructor(SettingByElements) {
      this.mutationObserver = null
      this.SettingByElements = SettingByElements
      this.initialize()
    }

    initialize() {
      this.newMutationObserver()
    }

    newMutationObserver() {
      // DOMの変更を監視し、要素が追加された場合にupdateSettingsを呼ぶ
      this.mutationObserver = new MutationObserver(() => {
        if (document.querySelectorAll('[data-view-log]').length === 0) return

        this.SettingByElements.updateSettings()
      })
      const options = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-view-log']
      }
      this.mutationObserver.observe(document.body, options)
    }
  }

  $(window).on('load', function() {
    const settingByElements = new SettingByElements()
    settingByElements.updateSettings()
    new ViewLogMutationObserver(settingByElements)
  })
})
